import { render } from "./Affirm.vue?vue&type=template&id=888f005e&scoped=true"
import script from "./Affirm.vue?vue&type=script&lang=js"
export * from "./Affirm.vue?vue&type=script&lang=js"

import "./Affirm.vue?vue&type=style&index=0&id=888f005e&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-888f005e"]])

export default __exports__